import React, { Component } from 'react';

class Loader extends Component {


    componentDidMount() {
        $('body').addClass('overlay-open');
    }

    componentWillUnmount() {
        $('body').removeClass('overlay-open');
    }

    render() {

        return (
            <div className="loading-dms" data-dms-ui={true} data-loading-spinner={true}>
                <div className="sk-circle">
                    <div className="sk-circle1 sk-child"></div>
                    <div className="sk-circle2 sk-child"></div>
                    <div className="sk-circle3 sk-child"></div>
                    <div className="sk-circle4 sk-child"></div>
                    <div className="sk-circle5 sk-child"></div>
                    <div className="sk-circle6 sk-child"></div>
                    <div className="sk-circle7 sk-child"></div>
                    <div className="sk-circle8 sk-child"></div>
                    <div className="sk-circle9 sk-child"></div>
                    <div className="sk-circle10 sk-child"></div>
                    <div className="sk-circle11 sk-child"></div>
                    <div className="sk-circle12 sk-child"></div>
                    <h2 className="u-text-center">
                        Loading
                    </h2>
                </div>

            </div>
        )
    }

}

export default Loader;

